"use client";

import { Fragment, useCallback, useEffect, useState } from "react";

import StepContainer from "../../../../components/new_components/StepContainer";
import { BottomSheet } from "../../../../components/new_components/BottomSheet";
import { WarningAlert } from "../../../../components/alerts/warningAlert";
import { InfoAlert } from "../../../../components/alerts/infoAlert";
import { ReactComponent as KeyIcon } from "./../../../../public/svg/Key.svg";
import { ReactComponent as FilesIcon } from "./../../../../public/svg/Files.svg";
import { HttpRequest } from "../../../../services/httpRequest";
import { ProgressLinear } from "../../../../components/progress/progressLinear";
import { useNavigate } from "react-router-dom";
import { montoElegido, otpResultado, trackEvent } from "../../../../services/analytics/track";
import { ErrorAlert } from "../../../../components/alerts/errorAlert";
import OtpComponente from "../../../../components/new_components/Otp";
import { ContractFirmaElectronicaV3 } from "../../../../components/new_components/Agreements/ContractFirmaElectronicaV1";
import { creditOfferStore } from "../../../../store/creditStore/offerCreditStore";
import { useCreditStore } from "../../../../store/creditStore/creditUserStore";
import { returnToSignin } from "../../../../utils/returnToSign";
import { useMobileDetection } from "../../../../hooks/use-mobile-detection";
import {
  getPostbackContext,
  storeUtmSettlement,
} from "../../../../services/utmleads/utmReferral";

const RenovarDatosOtp = ({
  onStepChange,
  stepTitlesGeneral,
  currentStepGeneral,
  isDesktop,
  currentStep: parentStep,
}) => {
  const navigate = useNavigate();

  const { offerCreditStore, loadOfertCredit } = creditOfferStore();
  const { creditUserStore, loadUser } = useCreditStore();
  const { screenHeight } = useMobileDetection();

  const phone = localStorage.getItem("phone");
  const celularProtect = "********" + phone.substring(8);

  const [currentStep, setCurrentStep] = useState(1);
  const [currentText] = useState("Continuar");
  const [isLoading, setIsLoading] = useState(false);
  const [dialogOpenContratoFirma, setDialogOpenContratoFirma] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [isError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);

  const [isOpenInfo, setIsOpenInfo] = useState(false);

  const [viewProgress, setViewProgress] = useState(false);

  const [isTransitioning, setIsTransitioning] = useState(false);
  const [formDataOtp, setFormDataOtp] = useState({
    otp: "",
  });

  const [errors, setErrors] = useState({});

  const stepTitles = [
    isDesktop
      ? "Te enviamos el código OTP a tu WhatsApp."
      : "Firmar Documentos.",
  ];
  const stepSubTitles = [
    `Escribe el código de ó dígitos que te envíamos a tu celular registrado +57 ${celularProtect}`,
  ];

  const totalSteps = stepTitles.length;

  const getFormHeight = () => {
    if (screenHeight <= 490) return "200px";
    if (screenHeight <= 550) return "260px";
    if (screenHeight <= 599) return "300px";
    if (screenHeight <= 650) return "370px";
    if (screenHeight <= 800) return "470px";
    if (screenHeight <= 1000) return "660px";
    if (screenHeight > 1001) return "830px";
    return "820px";
  };

  const handleToggleDialogContratoFirma = () => {
    if (dialogOpenContratoFirma) {
      setDialogOpenContratoFirma(false);
    } else {
      setDialogOpenContratoFirma(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormDataOtp((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setIsDisabled(false);
  };

  const handleProgress = useCallback((isView) => {
    setViewProgress(isView);
  }, []);

  const validateStep = (step) => {
    const newErrors = {};

    switch (step) {
      case 1:
        if (!formDataOtp.otp || formDataOtp.otp.length !== 6) {
          newErrors.otp = "El código debe tener exactamente 6 dígitos.";
          return;
        }
        if (!/^\d{6}$/.test(formDataOtp.otp)) {
          newErrors.otp = "El código solo puede contener números.";
          return;
        }
        break;
      default:
        break;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStep(currentStep)) {
      handleSubmit();
    }
  };

  const handlePrevGeneral = () => {
    if (currentStep > 1) {
      setTimeout(() => {
        onStepChange(parentStep - 1);
      }, 150);
    }
  };

  const handlePrev = () => {
    if (currentStep === 1) {
      handlePrevGeneral();
      return;
    }
    if (currentStep > 1) {
      setIsDisabled(false);
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentStep((prev) => prev - 1);
        setIsTransitioning(false);
      }, 150);
    }
  };

  const claerAlert = useCallback(() => {
    setMessageAlert("");
    setAlertSession(false);
    setIsOpenInfo(false);
    setIsOpenWarning(false);
    setIsOpenError(false);
  }, []);

  const hasActiveCredit = async () => {
    try {
      let response = await HttpRequest.hasActiveCredit(
        localStorage.getItem("doc"),
      );
      return response.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    handleProgress(true);
    setIsLoading(true);
    let data = {
      doc: localStorage.getItem("doc"),
      idCredit: localStorage.getItem("credit_id"),
      token: formDataOtp.otp,
      postbackContext: getPostbackContext(),
    };
    try {
      /* console.log('Data enviada: ', data); */
      let hasActive = await hasActiveCredit();
      if (hasActive) {
        handleOpenAlert(
          "error",
          "No es posible llevar a cabo la firma, ya usted posee un crédito en estado Vigente.",
          true,
        );
        return;
      }
      const responseService = await HttpRequest.validateOtpSignature(data);
      trackEvent("otp_verificado", { contexto: "firma", resultado: otpResultado(responseService) });
      if (responseService.error) {
        if (
          responseService.message.code === "INVALIDTOKEN" ||
          responseService.message.code === 411
        ) {
          handleOpenAlert("error", "Token inválido", true);
          handleProgress(false);
          setIsLoading(false);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
        handleProgress(false);
        setIsLoading(false);
        handleOpenAlert("error", responseService?.message?.message, true);
      } else {
        storeUtmSettlement(responseService.message);
        trackEvent("credito_firmado", {
          revenue: montoElegido(offerCreditStore),
          currency: "COP",
          plazo_dias: offerCreditStore?.termInDays,
          tipo_cliente: "renovacion",
        });
        if (onStepChange) {
          onStepChange(parentStep + 1); // o el número de paso que desees
        }
        handleProgress(false);
        setIsLoading(false);
        localStorage.setItem("is_signin", true);
        return;
      }
    } catch (error) {
      handleProgress(false);
      setIsLoading(false);
      console.log(error);
      handleOpenAlert(
        "error",
        "Ocurrió un error inesperado, intenta mas tarde",
        true,
      );
      setTimeout(() => {
        returnToSignin(navigate);
      }, 5000);
    }
  };

  const handleOpenAlert = useCallback((type, message, isOpen) => {
    if (type === "warning") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenWarning(isOpen);

      setTimeout(() => {
        setMessageAlert("");
        setAlertSession(!isOpen);
        setIsOpenWarning(!isOpen);
      }, 6000);
    }

    if (type === "error") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenError(isOpen);

      setTimeout(() => {
        setMessageAlert("");
        setAlertSession(!isOpen);
        setIsOpenError(!isOpen);
      }, 8000);
    }
  }, []);

  const resendCodeSignature = useCallback(async () => {
    setDisableButton(true);

    let data = {
      doc: localStorage.getItem("doc"),
      phone: phone,
      credit_id: localStorage.getItem("credit_id"),
    };
    try {
      //const responseService = await HttpRequest.aceptarPagare(data);
      const responseService = await HttpRequest.requestSignature(data);
      if (responseService.error) {
        handleProgress(false);
        claerAlert();
        handleOpenAlert(
          "error",
          "Ups!, no pudimos enviar el código, intenta nuevamente!",
          true,
        );
        setDisableButton(false);
        return;
      }
      handleOpenAlert("success", "Código enviado exitosamente!!", true);
      setTimeout(() => {
        setDisableButton(false);
      }, 5000);
    } catch (error) {
      console.log(error);
      handleOpenAlert("error", error, true);
    }
  }, [phone, handleProgress, claerAlert, handleOpenAlert]);

  useEffect(() => {
    try {
      resendCodeSignature();
      claerAlert();
    } catch (error) {
      console.log(error);
    }
  }, [resendCodeSignature, claerAlert]);

  useEffect(() => {
    loadOfertCredit();
    loadUser();
  }, [loadOfertCredit, loadUser]);

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="space-y-6 flex flex-col items-center" style={{
            overflowY: "auto",
            height: !isDesktop && "58vh",
            marginBottom: "20px"
          }}>
            {!isDesktop && (
              <div className="text-center mb-6" style={{ width: "300px" }}>
                <p className="text-muted-foreground font-bold2 text-2xl">
                  Te enviamos el código OTP a tu WhatsApp.
                </p>
              </div>
            )}
            <div style={{ width: !isDesktop && "100%", display: !isDesktop && "flex", justifyContent: !isDesktop && "space-evenly" }}>
              <OtpComponente
                name="otp"
                id="otp"
                value={formDataOtp.otp}
                onChange={handleInputChange}
                isDesktop={isDesktop}
              ></OtpComponente>
            </div>
            {!isDesktop && (
              <div className="text-center" style={{ width: "310px" }}>
                <p
                  className="text-muted-foreground"
                  style={{
                    fontSize: "16px",
                  }}
                >
                  Escribe el código de ó dígitos que te envíamos a tu WhatsApp
                  registrado +57{celularProtect}
                </p>
              </div>
            )}
            {viewProgress ? (
              <Fragment>
                <ProgressLinear></ProgressLinear>
                <p style={{ fontSize: 13 }}>
                  Estamos validando tu código, por favor espera...
                </p>
              </Fragment>
            ) : (
              <Fragment>
                <button
                  onClick={() => {
                    trackEvent("otp_reenviado", { contexto: "firma" });
                    resendCodeSignature();
                  }}
                  type="button"
                  style={{
                    height: isDesktop ? "56px" : "70px",
                    backgroundColor: disableButton ? "#29214F" : "#565584",
                    borderRadius: "50px",
                    opacity: disableButton ? 0.5 : 1,
                    cursor: disableButton ? "not-allowed" : "pointer",
                    border: disableButton ? "2px solid #687099" : "none",
                    width: isDesktop && "300px",
                    fontSize: isDesktop ? "18px" : "22px",
                  }}
                  disabled={disableButton}
                  className={`flex w-full items-center rounded-xl justify-center gap-3 px-4 py-3 transition-all duration-200 font-medium shadow-xl text-base sm:text-xl`}
                >
                  <KeyIcon className="w-7 h-7" style={{ color: "#C9B8FF" }} />
                  <p style={{ color: "#C9B8FF" }}>Reenviar Código</p>
                </button>
              </Fragment>
            )}
            <button
              onClick={() => handleToggleDialogContratoFirma()}
              type="button"
              style={{
                height: isDesktop ? "56px" : "70px",
                backgroundColor: "#565584",
                borderRadius: "50px",
                width: isDesktop && "300px",
                fontSize: isDesktop ? "18px" : "22px",
                cursor: "pointer",
              }}
              className={`flex w-full items-center rounded-xl justify-center gap-3 px-4 py-3 transition-all duration-200 font-medium shadow-xl text-base sm:text-xl`}
            >
              <FilesIcon className="w-7 h-7" style={{ color: "#C9B8FF" }} />
              <p style={{ color: "#C9B8FF" }}>Contrato firma Electrónica</p>
            </button>
            <BottomSheet
              open={dialogOpenContratoFirma}
              onOpenChange={setDialogOpenContratoFirma}
              isDesktop={isDesktop}
              headerContent={<h2>Contrato Firma Electronica</h2>}
            >
              <div className="space-y-3 w-full">
                <div
                  className="h-full rounded-t-3xl overflow-auto"
                  style={{
                    backgroundColor: "#2C2447",
                    color: "#FAFAFA",
                  }}
                >
                  <ContractFirmaElectronicaV3
                    basicInfo={creditUserStore}
                    userinfo={offerCreditStore}
                  />
                </div>
              </div>
            </BottomSheet>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Fragment>
      {alertSession && (
        <>
          <WarningAlert
            isOpen={isOpenWarning}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></WarningAlert>
          <ErrorAlert
            isOpen={isOpenError}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></ErrorAlert>

          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></InfoAlert>
        </>
      )}
      <div className="w-full h-full">
        <StepContainer
          onNext={handleNext}
          onPrev={handlePrev}
          canGoNext={true}
          canGoPrev={false}
          errors={isError}
          disabled={isDisabled}
          isLastStep={currentStep === totalSteps}
          isLoading={isLoading}
          isDesktop={isDesktop}
          nextText={currentText}
          title={stepTitles[currentStep - 1]}
          subtitle={stepSubTitles[currentStep - 1]}
          finishText="Firmar"
        >
          <div
            className={`transition-all duration-300 ease-in-out ${isTransitioning
              ? "opacity-0 transform translate-x-4"
              : "opacity-100 transform translate-x-0"
              }`}
            style={{
              width: "-webkit-fill-available",
              overflowY: "auto",
              height: isDesktop ? "-webkit-fill-available" : getFormHeight(),
            }}
          >
            {!isDesktop && (
              <div className="mb-4 text-center flex flex-col items-center">
                <div className="text-sm" style={{ color: "#c8cbda" }}>
                  Paso {currentStepGeneral} de {stepTitlesGeneral.length}
                </div>
                <div className="mt-1" style={{ fontSize: 16 }}>
                  {currentStep && stepTitles[currentStep - 1]}
                </div>
              </div>
            )}
            {renderStep()}
          </div>
        </StepContainer>
      </div>
    </Fragment>
  );
};

export default RenovarDatosOtp;
